import { IconType } from "react-icons";
import {
    TbBarbell,
    TbBike,
    TbJumpRope,
    TbRun,
    TbStretching,
    TbSwimming,
    TbYoga,
} from "react-icons/tb";

/**
 * Special (core) training types.
 *
 * These documents in the `trainingTypes` collection are referenced directly by the
 * apps (Peak Apple / Peak Android / Peak PWA) and by session logic, so their IDs and
 * names must stay stable. Admins are blocked from renaming, editing, combining or
 * otherwise mutating them in the admin UI, and they are shown in green with an icon.
 *
 * Do NOT change these IDs. If a new core training type is introduced, add it here.
 */
export interface SpecialTrainingType {
    id: string;
    name: string;
    icon: IconType;
}

export const SPECIAL_TRAINING_TYPES: SpecialTrainingType[] = [
    { id: "oB8ETOXxYlhBCt7y2z7M", name: "Run", icon: TbRun },
    { id: "mv6pgaF6IiFhSLENckAR", name: "Swim", icon: TbSwimming },
    { id: "15W65zXsmdoUnJsiNfHd", name: "Strength", icon: TbBarbell },
    { id: "dIfzxH5z2FxekWZgxK6B", name: "Pilates", icon: TbStretching },
    { id: "oiWnRzAP6uNiNIMDYCeR", name: "Plyometrics", icon: TbJumpRope },
    { id: "gQLxre3WcvEoQeUXInBL", name: "Yoga", icon: TbYoga },
    { id: "K1SHpUttpEJQVkiYf7RC", name: "Bike Ride", icon: TbBike },
];

/** Lookup of special training types by document ID. */
export const SPECIAL_TRAINING_TYPES_BY_ID = new Map<string, SpecialTrainingType>(
    SPECIAL_TRAINING_TYPES.map((type) => [type.id, type])
);

/** Every special training type document ID. */
export const SPECIAL_TRAINING_TYPE_IDS = SPECIAL_TRAINING_TYPES.map((type) => type.id);

/** True when the given training type ID is one of the protected special types. */
export const isSpecialTrainingType = (id?: string): boolean =>
    !!id && SPECIAL_TRAINING_TYPES_BY_ID.has(id);

/** The special training type definition for an ID, or undefined when not special. */
export const getSpecialTrainingType = (id?: string): SpecialTrainingType | undefined =>
    id ? SPECIAL_TRAINING_TYPES_BY_ID.get(id) : undefined;
